<div class="flex flex-column gap-3 p-3 border-1 surface-border border-round-lg" data-test="ui-ql-widget-type-editor">

    <span class="text-lg font-semibold">Darstellung</span>

    <p-selectButton [options]="typeOptions" optionLabel="label" optionValue="value" optionDisabled="disabled"
                    [ngModel]="widgetType" (ngModelChange)="selectType($event)" [allowEmpty]="false"
                    data-test="ui-ql-widget-type-select">
        <ng-template #item let-option>
            <span class="flex align-items-center gap-2" [pTooltip]="option.tooltip" tooltipPosition="bottom">
                <i [class]="option.icon"></i>{{ option.label }}
            </span>
        </ng-template>
    </p-selectButton>

    @if (disabledTypesReason) {
        <span class="text-sm text-color-secondary" data-test="ui-ql-widget-type-disabled-reason">
            <i class="fa-regular fa-circle-info mr-1"></i>{{ disabledTypesReason }}
        </span>
    }

    @switch (widgetType) {
        @case ('table') {
            <span class="text-sm text-color-secondary">Die Spalten der Tabelle sind die im Builder gewählten Felder.</span>
        }
        @case ('list') {
            <span class="text-sm text-color-secondary">Die Liste zeigt die im Builder gewählten Felder als Karten.</span>
        }
    }

    @if (needsGroupBy) {
        <p-message severity="warn" styleClass="w-full" data-test="ui-ql-widget-type-needs-group-by">
            <div class="flex flex-column gap-2">
                <span>{{ textGroupByRequired }} Im Builder den Schalter „Gruppieren/Aggregieren“ einschalten oder hier aktivieren.</span>
                <div class="flex align-items-center gap-2">
                    <span [pTooltip]="enableGroupByBlockedReason ?? ''">
                        <p-button label="Gruppierung aktivieren" icon="fa-regular fa-layer-group" size="small"
                                  [disabled]="!!enableGroupByBlockedReason"
                                  data-test="ui-ql-widget-type-enable-group-by"
                                  (onClick)="enableGroupBy()"></p-button>
                    </span>
                    @if (enableGroupByBlockedReason) {
                        <span class="text-sm">{{ enableGroupByBlockedReason }}</span>
                    }
                </div>
            </div>
        </p-message>
    } @else {

        @if (widgetType === 'chart') {
            <div class="grid formgrid p-fluid m-0">
                <div class="field col-6">
                    <label for="uiQlChartType">Diagrammart</label>
                    <p-select inputId="uiQlChartType" [options]="chartTypeOptions" optionLabel="label" optionValue="value"
                              [ngModel]="chartMapping.chartType" (ngModelChange)="setMappingValue('chartType', $event)"
                              appendTo="body"></p-select>
                </div>
                <div class="field col-6">
                    <label for="uiQlChartFn">Aggregat</label>
                    <p-select inputId="uiQlChartFn" [options]="functionOptions" optionLabel="label" optionValue="value"
                              [ngModel]="chartMapping.chartAggregateFunction"
                              (ngModelChange)="setMappingValue('chartAggregateFunction', $event)"
                              appendTo="body"></p-select>
                </div>
                <div class="field col-6">
                    <label for="uiQlChart1st">X-Achse (Gruppierung)</label>
                    <p-select inputId="uiQlChart1st" [options]="groupKeyOptions" optionLabel="label" optionValue="value"
                              [ngModel]="chartMapping.chartField1st" (ngModelChange)="setMappingValue('chartField1st', $event)"
                              placeholder="Gruppierungsfeld wählen" appendTo="body">
                        <ng-template #selectedItem let-option>
                            <span>{{ option?.label }}</span>
                            <span class="text-sm text-color-secondary ml-2">{{ option?.value }}</span>
                        </ng-template>
                        <ng-template #item let-option>
                            <div class="flex flex-column">
                                <span>{{ option.label }}</span>
                                <span class="text-sm text-color-secondary">{{ option.value }}</span>
                            </div>
                        </ng-template>
                    </p-select>
                </div>
                <div class="field col-6">
                    <label for="uiQlChartAgg">Wert (Kennzahl)</label>
                    <p-select inputId="uiQlChartAgg" [options]="aggregateKeyOptions" optionLabel="label" optionValue="value"
                              [ngModel]="chartMapping.chartFieldAggregate"
                              (ngModelChange)="setMappingValue('chartFieldAggregate', $event)"
                              placeholder="Kennzahl wählen" appendTo="body">
                        <ng-template #selectedItem let-option>
                            <span>{{ option?.label }}</span>
                            <span class="text-sm text-color-secondary ml-2">{{ option?.value }}</span>
                        </ng-template>
                        <ng-template #item let-option>
                            <div class="flex flex-column">
                                <span>{{ option.label }}</span>
                                <span class="text-sm text-color-secondary">{{ option.value }}</span>
                            </div>
                        </ng-template>
                    </p-select>
                </div>
                <div class="field col-6">
                    <label for="uiQlChart2nd">Serie (optional)</label>
                    <p-select inputId="uiQlChart2nd" [options]="groupKeyOptions" optionLabel="label" optionValue="value"
                              [ngModel]="chartMapping.chartField2nd ?? null" [showClear]="true"
                              (ngModelChange)="setMappingValue('chartField2nd', $event)"
                              placeholder="keine" appendTo="body">
                        <ng-template #selectedItem let-option>
                            <span>{{ option?.label }}</span>
                            <span class="text-sm text-color-secondary ml-2">{{ option?.value }}</span>
                        </ng-template>
                        <ng-template #item let-option>
                            <div class="flex flex-column">
                                <span>{{ option.label }}</span>
                                <span class="text-sm text-color-secondary">{{ option.value }}</span>
                            </div>
                        </ng-template>
                    </p-select>
                </div>
            </div>
        }

        @if (widgetType === 'category') {
            <div class="grid formgrid p-fluid m-0">
                <div class="field col-6">
                    <label for="uiQlCategory">Kategorie (Gruppierung)</label>
                    <p-select inputId="uiQlCategory" [options]="groupKeyOptions" optionLabel="label" optionValue="value"
                              [ngModel]="categoryMapping.fieldCategory" (ngModelChange)="setMappingValue('fieldCategory', $event)"
                              placeholder="Gruppierungsfeld wählen" appendTo="body">
                        <ng-template #selectedItem let-option>
                            <span>{{ option?.label }}</span>
                            <span class="text-sm text-color-secondary ml-2">{{ option?.value }}</span>
                        </ng-template>
                        <ng-template #item let-option>
                            <div class="flex flex-column">
                                <span>{{ option.label }}</span>
                                <span class="text-sm text-color-secondary">{{ option.value }}</span>
                            </div>
                        </ng-template>
                    </p-select>
                </div>
                <div class="field col-6">
                    <label for="uiQlCategoryCount">Anzahl (Kennzahl)</label>
                    <p-select inputId="uiQlCategoryCount" [options]="aggregateKeyOptions" optionLabel="label" optionValue="value"
                              [ngModel]="categoryMapping.fieldCategoryCount"
                              (ngModelChange)="setMappingValue('fieldCategoryCount', $event)"
                              placeholder="Kennzahl wählen" appendTo="body">
                        <ng-template #selectedItem let-option>
                            <span>{{ option?.label }}</span>
                            <span class="text-sm text-color-secondary ml-2">{{ option?.value }}</span>
                        </ng-template>
                        <ng-template #item let-option>
                            <div class="flex flex-column">
                                <span>{{ option.label }}</span>
                                <span class="text-sm text-color-secondary">{{ option.value }}</span>
                            </div>
                        </ng-template>
                    </p-select>
                </div>
                <div class="field col-6">
                    <label for="uiQlCategoryMode">Darstellung</label>
                    <p-select inputId="uiQlCategoryMode" [options]="displayModeOptions" optionLabel="label" optionValue="value"
                              [ngModel]="categoryMapping.displayMode" (ngModelChange)="setMappingValue('displayMode', $event)"
                              appendTo="body"></p-select>
                </div>
            </div>
        }

        @if ((widgetType === 'chart' || widgetType === 'category') && !groupKeyOptions.length) {
            <span class="text-sm text-color-secondary">
                Noch kein Gruppierungsfeld – im Builder unter „Gruppieren nach“ ein Feld hinzufügen.
            </span>
        }

        @if (extraGroupKeys.length) {
            <p-message severity="warn" styleClass="w-full" data-test="ui-ql-widget-type-extra-group-keys">
                <div class="flex flex-column gap-2">
                    <span>
                        Weitere Gruppenschlüssel: {{ extraGroupKeys.join(', ') }} – die Felder der Verknüpfungen teilen jede
                        Gruppe zusätzlich auf. Für ein Diagramm oder eine Kategorie sind meist nur die Gruppierungsfelder der
                        Start-Entität gewollt.
                    </span>
                    <div>
                        <p-button label="Zusätzliche Schlüssel entfernen" icon="fa-regular fa-eraser" size="small"
                                  severity="secondary" [outlined]="true" data-test="ui-ql-widget-type-clear-join-fields"
                                  pTooltip="Entfernt die Felder der Verknüpfungen – die Gruppen werden dann nur noch von den Gruppierungsfeldern der Start-Entität gebildet."
                                  (onClick)="clearJoinFields()"></p-button>
                    </div>
                </div>
            </p-message>
        }

        @if (mappingIssues.length) {
            <p-message severity="error" styleClass="w-full" data-test="ui-ql-widget-type-mapping-issues">
                <div class="flex flex-column gap-2">
                    <ul class="m-0 pl-3 flex flex-column gap-1">
                        @for (issue of mappingIssues; track $index) {
                            <li>{{ issue }}</li>
                        }
                    </ul>
                    <div>
                        <p-button label="Automatisch zuordnen" icon="fa-regular fa-wand-magic-sparkles" size="small"
                                  severity="secondary" [outlined]="true" (onClick)="autoMap()"></p-button>
                    </div>
                </div>
            </p-message>
        }
    }
</div>
